"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorWithEmailViewContainer = TwoFactorWithEmailViewContainer;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _ContentLayout = require("../../components/ContentLayout");
var _ConfirmationSmsCodeForm = require("../../components/ConfirmationSmsCodeForm");
var _index = require("../../../index");
var _validation = require("../../utils/validation");
var _view = require("../../types/view");
var _tracking = require("../../utils/tracking");
var _SubtitleLayout = require("../../components/SubtitleLayout");
var _HelpContainer = require("../HelpContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TwoFactorWithEmailViewContainer(_ref) {
  let {
    isSubmitting,
    hasCodeError,
    codeError,
    reset,
    emit,
    authenticate,
    changeView
  } = _ref;
  // FORM
  const [touched, setTouched] = React.useState(false);
  const [changed, setChanged] = React.useState(false);
  // CODE
  const codeRef = React.useRef(null);
  const [code, setCode] = React.useState('');
  const [isCodeInvalid, setCodeInvalid] = React.useState(true);
  const validateCode = React.useCallback(code => {
    if (!(0, _validation.isValidCode)(code)) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    authenticate({
      code
    });
    emit(_index.EEventType.TwoFactorContinueClick);
    setChanged(false);
  }, [emit, authenticate]);
  const handleCantConfirmClick = React.useCallback(() => {
    (0, _tracking.trackTwoFactorCannotConfirmClick)(_index.ETwoFactorType.Email);
    emit(_index.EEventType.TwoFactorCannotConfirmClick);
  }, [emit]);
  const handleCodeChange = React.useCallback(e => {
    const {
      value
    } = e.currentTarget;
    const nextValue = value.replace(/\D+/g, '');
    if (nextValue.length > 4) {
      return;
    }
    setCode(nextValue);
    setChanged(true);
    setCodeInvalid((0, _validation.isValidCode)(nextValue));
    validateCode(nextValue);
  }, [validateCode]);
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    (0, _tracking.trackTwoFactorContinueClick)(_index.ETwoFactorType.Email);
    if (isSubmitting) {
      return;
    }
    if (isCodeInvalid) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    validateCode(code);
  }, [code, isCodeInvalid, isSubmitting, validateCode]);
  const switchToRegister = React.useCallback(() => {
    (0, _tracking.trackTwoFactorClose)(_index.ETwoFactorType.Email);
    reset();
    changeView(_view.EActiveView.AuthenticationRegistration);
  }, [reset, changeView]);
  React.useEffect(() => {
    (0, _tracking.trackTwoFactorPopupOpen)(_index.ETwoFactorType.Email);
  }, []);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, null, "\u0412\u044B\xA0\u0437\u0430\u0445\u043E\u0434\u0438\u0442\u0435 \u0441\xA0\u043D\u0435\u0433\u043E \u0432\u043F\u0435\u0440\u0432\u044B\u0435, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u043C\u044B\xA0\u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C\xA0\u043F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u044B\u0439 \u043A\u043E\u0434\xA0\u0441\xA0\u043F\u043E\u0447\u0442\u044B noreply@cian.ru\xA0\u2014 \u0438\u043D\u043E\u0433\u0434\u0430 \u0442\u0430\u043A\u0438\u0435 \u043F\u0438\u0441\u044C\u043C\u0430 \u043F\u043E\u043F\u0430\u0434\u0430\u044E\u0442 \u0432\xA0\u043F\u0430\u043F\u043A\u0443 \u0441\u043F\u0430\u043C"), /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_ConfirmationSmsCodeForm.ConfirmationSmsCodeForm, {
    isSubmitting: isSubmitting,
    handleSubmit: handleSubmit,
    submitButtonText: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
    codeRef: codeRef,
    code: code,
    onCodeChange: handleCodeChange,
    codeError: touched && !changed ? codeError : undefined,
    isCodeInvalid: touched && (isCodeInvalid || hasCodeError && !changed),
    resendAvailable: false,
    resendTimeout: null,
    buttons: /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "SwitchToRegisterBtn",
      fullWidth: true,
      theme: "fill_secondary",
      onClick: switchToRegister
    }, "\u041E\u0442\u043C\u0435\u043D\u0430")
  })), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    text: "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
    onClick: handleCantConfirmClick
  }));
}